import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { DrawerPopupWebElement } from './DrawerPopupWebElement';
export { DrawerPopupWebElement };

/**
 * Retrieve an instance of [DrawerPopupWebElement](../classes/DrawerPopupWebElement.html).
 * @example
 * ```javascript
 * import { findDrawerPopup } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findDrawerPopup(driver, By.id('my-oj-c-drawer-popup'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findDrawerPopup(driver: DriverLike, by: By): Promise<DrawerPopupWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type DrawerPopupWebElement
  if (!(webEl instanceof DrawerPopupWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'DrawerPopupWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findDrawerPopup(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${DrawerPopupWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-drawer-popup', DrawerPopupWebElement);
